import React from "react";
import { Link } from "react-router-dom";

function PrivacyPolicy() {
  return (
    <div>
      <div className="positioning mb-5">
        <div className="container-fluid blog">
          <div className="container">
            <div className="row align-items-center justify-content-between">
              <div className="col-12">
                <div className="text-center">
                  <h1 className="section-heading">Privacy Policy</h1>
                  <p>
                    <Link to="/">Home</Link> /{" "}
                    <Link to="/privacy-policy">Privacy Policy</Link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="blog-post-area">
        <div className="container px-5 shadow-sm rounded-3 p-5 border-top border-light border-2 border-animate-t">
          <p className="mb-4">
            aPLS Web Development ("aPLS", "we", "us", or "our") respects your
            privacy. This Privacy Policy explains how information may be
            collected, used, and protected when you visit our website or contact
            us about our services.
          </p>

          <section className="pb-4 pt-2">
            <h5 className="text-xl font-semibold text-gray-800">
              Information We May Collect
            </h5>
            <p>
              We may receive information you choose to provide when you contact
              us, request a demo, apply for a role, or otherwise communicate
              with us. This may include your name, contact details, organization,
              and the contents of your message. When you visit the website,
              technical information such as your browser, device, and interaction
              with pages may also be processed by the website or its hosting
              services.
            </p>
          </section>
          <hr />

          <section className="pb-4 pt-2">
            <h5 className="text-xl font-semibold text-gray-800">
              How We Use Information
            </h5>
            <ul className="list-disc list-inside space-y-2">
              <li>To respond to questions and requests you send us.</li>
              <li>
                To provide information about our services and manage our
                business communications.
              </li>
              <li>
                To operate, maintain, and improve the website and help protect
                it from misuse.
              </li>
              <li>
                To meet applicable legal obligations and resolve disputes.
              </li>
            </ul>
          </section>
          <hr />

          <section className="pb-4 pt-2">
            <h5 className="text-xl font-semibold text-gray-800">
              Cookies and Similar Technologies
            </h5>
            <p>
              The website or its service providers may use cookies or similar
              technologies for essential site functions, preferences, and
              website performance. You can manage cookies through your browser
              settings; disabling them may affect some website features.
            </p>
          </section>
          <hr />

          <section className="pb-4 pt-2">
            <h5 className="text-xl font-semibold text-gray-800">
              Sharing Information
            </h5>
            <p>
              We do not sell personal information. We may share information
              with service providers who help us operate the website or deliver
              our services, where necessary to respond to your request, or when
              required by law. Service providers are expected to handle
              information for the purposes for which it was shared.
            </p>
          </section>
          <hr />

          <section className="pb-4 pt-2">
            <h5 className="text-xl font-semibold text-gray-800">
              Data Retention and Security
            </h5>
            <p>
              We retain information for as long as reasonably needed for the
              purposes described in this Policy, including business, security,
              and legal purposes. We use reasonable safeguards designed to
              protect information, but no method of transmission or storage can
              be guaranteed to be completely secure.
            </p>
          </section>
          <hr />

          <section className="pb-4 pt-2">
            <h5 className="text-xl font-semibold text-gray-800">
              Your Choices and Rights
            </h5>
            <p>
              Depending on where you live, you may have rights to request access
              to, correction of, or deletion of personal information, or to
              object to or restrict certain processing. You can also choose not
              to provide information, though we may then be unable to respond
              fully to your request. Contact us using the contact information
              provided on this website to make a privacy request.
            </p>
          </section>
          <hr />

          <section className="pb-4 pt-2">
            <h5 className="text-xl font-semibold text-gray-800">
              Third-Party Websites
            </h5>
            <p>
              Our website may link to third-party websites or services. Their
              privacy practices are governed by their own policies, and we
              encourage you to review those policies when you visit them.
            </p>
          </section>
          <hr />

          <section className="pb-4 pt-2">
            <h5 className="text-xl font-semibold text-gray-800">
              Changes to This Policy
            </h5>
            <p>
              We may update this Privacy Policy from time to time. Any revised
              version will be posted on this page. Your continued use of the
              website after a change is posted indicates your use is subject to
              the revised Policy.
            </p>
          </section>
          <hr />

          <section className="pb-2 pt-2">
            <h5 className="text-lg font-semibold text-gray-800 text-center">
              Contact Us
            </h5>
            <p className="text-center text-gray-600">
              For questions or requests about this Privacy Policy, please
              contact aPLS Web Development using the contact details on our
              website.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;